"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = exports.ColStyled = exports.ContentWrapper = exports.VideoItemWrapper = exports.VideoWrapper = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _styledComponents = require("styled-components");

var _video = require("../../../components/video/video.styled");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  flex-direction: ", ";\n  min-height: 650px;\n  margin: 0;\n  position: relative;\n  text-align: ", ";\n  justify-content: center;\n  width: 100%;\n\n  ", "\n\n  ", " {\n    height: 100%;\n    flex-direction: column-reverse;\n    min-height: auto;\n  }\n\n  ", "\n\n  .slick-slider & {\n    ", " {\n      height: auto;\n      flex-direction: column;\n      justify-content: flex-start;\n\n      ", " {\n        &:nth-of-type(1) {\n          order: 2;\n          flex: none !important;\n        }\n\n        &:nth-of-type(2) {\n          flex: 1 !important;\n\n          ", " {\n            height: 100%;\n            min-height: 211px;\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  z-index: 1;\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  opacity: 0;\n  padding: 30px;\n  margin: auto;\n  max-width: 540px;\n  transition: opacity ease-in 0.3s, visibility ease-in 0.3s;\n  visibility: hidden;\n\n  ", " {\n    transition: none;\n  }\n\n  ", "\n\n  ", " {\n    padding: 40px 24px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 100% !important;\n  width: 100% !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%;\n\n  ", " {\n    height: 211px;\n    position: relative;\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var VideoWrapper = (0, _uiKit.styled)(_uiKit.Box)(_templateObject(), _uiKit.GridBreakpointsMediaDown.sm, function (_ref) {
  var isPlaying = _ref.isPlaying;
  return !isPlaying && (0, _styledComponents.css)(["&::before{content:'';position:absolute;left:0;right:0;top:0;bottom:0;background:", ";opacity:0.5;z-index:1;}", "{z-index:1;}"], _uiKit.Colors.gray800, _video.PlayButton);
});
exports.VideoWrapper = VideoWrapper;
var VideoItemWrapper = (0, _uiKit.styled)("div")(_templateObject2());
exports.VideoItemWrapper = VideoItemWrapper;
var ContentWrapper = (0, _uiKit.styled)("div")(_templateObject3(), _video.PlayButton, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? (0, _styledComponents.css)(["opacity:1;visibility:visible;"]) : "";
}, _uiKit.GridBreakpointsMediaDown.sm);
exports.ContentWrapper = ContentWrapper;
var ColStyled = (0, _uiKit.styled)(_uiKit.Col)(_templateObject4(), function (_ref3) {
  var fullWidth = _ref3.fullWidth,
      showBtn = _ref3.showBtn,
      $isPlaying = _ref3.theme.$isPlaying;
  return fullWidth && (0, _styledComponents.css)(["position:static;z-index:0;", "{", "}@media (max-height:610px),(max-width:", "px){", "{display:block;", "}}"], _video.PlayButton, showBtn ? (0, _styledComponents.css)(["opacity:1;visibility:visible;"]) : (0, _styledComponents.css)(["opacity:0;visibility:hidden;"]), _uiKit.GridBreakpointsMax.sm, _video.PlayButton, !$isPlaying ? (0, _styledComponents.css)(["display:block;opacity:1;visibility:visible;"]) : (0, _styledComponents.css)(["opacity:0;visibility:visible;"]));
});
exports.ColStyled = ColStyled;
var Container = (0, _uiKit.styled)(_uiKit.Row)(_templateObject5(), function (_ref4) {
  var textBackgroundColor = _ref4.textBackgroundColor;
  return textBackgroundColor ? _uiKit.Colors[textBackgroundColor] : 'transparent';
}, function (_ref5) {
  var textColor = _ref5.textColor;
  return textColor ? _uiKit.Colors[textColor] : 'currentColor';
}, function (_ref6) {
  var contentPosition = _ref6.contentPosition;
  return contentPosition === 'left' ? 'row' : 'row-reverse';
}, function (_ref7) {
  var textAlign = _ref7.textAlign;
  return textAlign;
}, function (_ref8) {
  var onClick = _ref8.onClick;
  return onClick && "cursor: pointer; user-select: none;";
}, _uiKit.GridBreakpointsMediaDown.sm, function (_ref9) {
  var hideMdHeight = _ref9.hideMdHeight;
  return hideMdHeight && (0, _styledComponents.css)(["", "{", "{display:none;}}@media (max-height:610px) and (min-width:", "px){min-height:405px !important;}@media (max-height:610px){", "{display:none;}}"], _uiKit.GridBreakpointsMediaDown.sm, ContentWrapper, _uiKit.GridBreakpointsMax.sm, ContentWrapper);
}, _uiKit.GridBreakpointsMediaDown.sm, ColStyled, VideoWrapper);
exports.Container = Container;